// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@crehana/i18n';
import { SHOPPING_CART_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import Text from 'crehana-ui/Text';
import Container from 'Shared/ui/Container';
import GridItemsList from '../GridItemsList/GridItemsList';

const Root = styled.div`
  .itemcard-wrapper {
    border-bottom: 1px solid #d4d4d4;
    &:nth-last-child(1) {
      border-bottom: none;
    }
    @media (min-width: 1024px) {
      &:nth-last-child(2) {
        border-bottom: none;
      }
    }
  }
`;

const RecentlySeenCourses = ({ items }) => {
  const { t } = useTranslation(SHOPPING_CART_TRANSLATION_KEY);

  return (
    <Root className="mb-64">
      <Container>
        <div className="flex items-center">
          <Text type="h4" as="p">
            {t('RECENTLY_SEEN')}
          </Text>
        </div>
      </Container>
      <div style={{ marginBottom: -24 }}>
        <GridItemsList items={items} origin="Recently seen courses section" />
      </div>
    </Root>
  );
};

export default RecentlySeenCourses;
